












import Vue from "vue"
export default Vue.extend({
  name: 'notificationsuccess',
  props: {
    title: String,
    message: String
  },
})
